// extracted by mini-css-extract-plugin
export default {"ring_container":"RotatingRing_ring_container__FvDN6","ring":"RotatingRing_ring__IWRUK","spin":"RotatingRing_spin__fkudC"};